import React from "react";
import { motion } from "framer-motion";
import {
  StretchHorizontal,
  Zap, Briefcase, Siren,
} from "lucide-react";

const features = [
  { Icon: StretchHorizontal, title: "5 Doctor-Recommended Stretches", desc: "Targeted stretches proven to relieve back tension fast.", color: "from-emerald-50 to-emerald-100", iconColor: "text-emerald-600" },
  { Icon: Zap, title: "Sciatica Pain Tips", desc: "Calm sciatic nerve pain with home techniques.", color: "from-yellow-50 to-yellow-100", iconColor: "text-yellow-600" },
  { Icon: Briefcase, title: "Office Workers Back Care", desc: "Micro-breaks & exercises designed for desk jobs.", color: "from-slate-50 to-slate-100", iconColor: "text-slate-700" },
  { Icon: Siren, title: "Emergency Pain Reduction", desc: "Fast relief techniques for sudden flare-ups.", color: "from-rose-50 to-rose-100", iconColor: "text-rose-600" },
];

export default function WhatsInside() {
  return (
    <section id="whats-inside" className="py-20 md:py-28 bg-slate-50" data-testid="whats-inside-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <div className="text-xs font-bold uppercase tracking-[0.2em] text-emerald-600 mb-3">
            What&apos;s Inside
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-[#1E3A8A] leading-tight" style={{ fontFamily: "Outfit" }}>
            Everything You Need to{" "}
            <span className="text-emerald-600">Live Pain-Free</span>
          </h2>
          <p className="mt-4 text-base sm:text-lg text-slate-600 leading-relaxed">
            4 focused chapters built from a decade of clinical experience by an orthopedic surgeon.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 lg:gap-6">
          {features.map(({ Icon, title, desc, color, iconColor }, idx) => (
            <motion.div
              key={title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.4, delay: idx * 0.06 }}
              whileHover={{ y: -4 }}
              className="group bg-white rounded-2xl p-6 border border-slate-100 shadow-sm hover:shadow-xl hover:border-slate-200 transition-all duration-300"
              data-testid={`feature-card-${idx}`}
            >
              <div className={`w-14 h-14 rounded-2xl bg-gradient-to-br ${color} flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300`}>
                <Icon className={`w-7 h-7 ${iconColor}`} strokeWidth={2} />
              </div>
              <h3 className="text-base sm:text-lg font-bold text-[#0F172A] mb-2 leading-snug" style={{ fontFamily: "Outfit" }}>
                {title}
              </h3>
              <p className="text-sm text-slate-600 leading-relaxed">{desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
